// extracted by mini-css-extract-plugin
export default {"widget":"QuantityWidget_widget"};